import * as React from 'react';
import { QuickLinkItem } from './components/QuickLinkItem';
import * as styles from './QuickLinksList.css';
import { IQuickLink } from '../../../../../common/state';
import { QuickLinksTitle } from '../QuickLinksTitle';

export interface IQuickLinksListProps {
  linkGroups: IQuickLink[][];
  level: number;
}

export function QuickLinksList(props: IQuickLinksListProps) {
  const { linkGroups, level } = props;

  return (
    <div className={styles['section']}>
      <QuickLinksTitle>Рекомендуем посмотреть</QuickLinksTitle>
      <div className={styles['list']}>
        {linkGroups.map((links, index) => {
          return (
            <div key={`quicks_link_${index}`} className={styles['column']}>
              {links.map((link, i) => {
                return (
                  <QuickLinkItem
                    key={`quick_link_${i}`}
                    level={level}
                    url={link.url}
                    offersCount={link.offersCount}
                    title={link.title}
                  />
                );
              })}
            </div>
          );
        })}
      </div>
    </div>
  );
}
